//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import {
    IssueManagementIssueFilter,
    IssueManagementIssueTypeFilter,
} from "shared/search/containers/Filter/IssueManagementFilters"

import { createCustomFilterGroup } from "shared/search/containers/FilterGroup/CustomFilterGroup"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const IssueManagementIssueTypeFilterGroup = (props) => genericFilterGroup(props)
IssueManagementIssueTypeFilterGroup.propTypes = defaultProps
IssueManagementIssueTypeFilterGroup.defaultProps = {
    filters: [IssueManagementIssueTypeFilter, IssueManagementIssueFilter],
    uniqueFilterGroupId: "issueManagementIssueTypeFilterGroup",
    displayLabel: "Issue Type",
    helpText: "Filter results by primary or sub issues.",
}

export const IssueManagementCustomFilterGroup = createCustomFilterGroup(
    "issueManagementCustomFilterGroup",
    DjangIO.app.models.QuorumDataType.issue_management.value,
)
